/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('member.personal', {
            abstract: true,
            parent: 'member',
            views: {
                'content@': {
                    templateUrl: 'app/member/personal/personalNavbar.html',
                    controller: 'PersonalNavbarController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
